var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCharm = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 1200,
  height: 1200,
  viewBox: "0 0 900 900"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M117.684 117.684h664.5v664.5h-664.5Zm0 0"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "b"
}, /*#__PURE__*/React.createElement("path", {
  d: "M156.852 156.852h586.5v586.5h-586.5Zm0 0"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "c"
}, /*#__PURE__*/React.createElement("path", {
  d: "M500 298h86v82h-86Zm0 0"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "d"
}, /*#__PURE__*/React.createElement("path", {
  d: "m484.36 339.363 47.19-57.62 70.227 57.51-47.191 57.622Zm0 0"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "e"
}, /*#__PURE__*/React.createElement("path", {
  d: "M507.957 310.55c-13.031 15.915-7.894 41.673 11.477 57.536 19.367 15.863 45.636 15.824 58.668-.09 13.03-15.91 7.89-41.668-11.48-57.531-19.368-15.863-45.634-15.824-58.665.086Zm0 0"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "f"
}, /*#__PURE__*/React.createElement("path", {
  d: "M118.086 58.594h99.102v70.437h-99.102Zm0 0"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "g"
}, /*#__PURE__*/React.createElement("path", {
  d: "m176.395 63.098 39.152 53.804a7.63 7.63 0 0 1 .629 7.957 7.632 7.632 0 0 1-6.805 4.172h-83.605a7.641 7.641 0 0 1-6.805-4.172 7.639 7.639 0 0 1 .633-7.957l39.148-53.804a10.915 10.915 0 0 1 17.653 0Zm0 0"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "h"
}, /*#__PURE__*/React.createElement("path", {
  d: "M422 421h198v204H422Zm0 0"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "i"
}, /*#__PURE__*/React.createElement("path", {
  d: "m642.723 599.555-217.508 31.328-26.406-183.348 217.507-31.328Zm0 0"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "j"
}, /*#__PURE__*/React.createElement("path", {
  d: "m642.723 599.555-217.508 31.328-26.406-183.348 217.507-31.328Zm0 0"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "k"
}, /*#__PURE__*/React.createElement("path", {
  d: "m642.723 599.555-217.508 31.328-26.406-183.348 217.507-31.328Zm0 0"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "l"
}, /*#__PURE__*/React.createElement("path", {
  d: "M406 409h198v204H406Zm0 0"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "m"
}, /*#__PURE__*/React.createElement("path", {
  d: "m627.148 587.734-217.507 31.328-26.407-183.343 217.504-31.328Zm0 0"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "n"
}, /*#__PURE__*/React.createElement("path", {
  d: "m627.148 587.734-217.507 31.328-26.407-183.343 217.504-31.328Zm0 0"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "o"
}, /*#__PURE__*/React.createElement("path", {
  d: "m627.148 587.734-217.507 31.328-26.407-183.343 217.504-31.328Zm0 0"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "p"
}, /*#__PURE__*/React.createElement("path", {
  d: "M564 412h55v55h-55Zm0 0"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "q"
}, /*#__PURE__*/React.createElement("path", {
  d: "M564.96 411.566 619 413.45l-1.887 54.04-54.035-1.884Zm0 0"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "r"
}, /*#__PURE__*/React.createElement("path", {
  d: "M591.98 412.508c-14.921-.52-27.44 11.156-27.96 26.078-.52 14.922 11.152 27.441 26.078 27.96 14.922.52 27.437-11.155 27.96-26.077.52-14.922-11.156-27.442-26.078-27.961Zm0 0"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "s"
}, /*#__PURE__*/React.createElement("path", {
  d: "M410 569h55v55h-55Zm0 0"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "t"
}, /*#__PURE__*/React.createElement("path", {
  d: "m411.152 568.574 54.04 1.883-1.883 54.04-54.04-1.884Zm0 0"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "u"
}, /*#__PURE__*/React.createElement("path", {
  d: "M438.172 569.516c-14.922-.52-27.442 11.156-27.961 26.078-.52 14.922 11.156 27.441 26.078 27.96 14.922.52 27.441-11.156 27.961-26.077.52-14.922-11.156-27.442-26.078-27.961Zm0 0"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "v"
}, /*#__PURE__*/React.createElement("path", {
  d: "M117.684 121.043h99.77v347.3h-99.77Zm0 0"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "w"
}, /*#__PURE__*/React.createElement("path", {
  d: "M188 682h499v171H188Zm0 0"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "x"
}, /*#__PURE__*/React.createElement("path", {
  d: "m380.504 546.11 326.984 252.695-212.797 275.355-326.984-252.695Zm0 0"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "y"
}, /*#__PURE__*/React.createElement("path", {
  d: "m380.504 546.11 326.984 252.695-212.797 275.355-326.984-252.695Zm0 0"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "z"
}, /*#__PURE__*/React.createElement("path", {
  d: "m380.504 546.11 326.984 252.695-212.797 275.355-326.984-252.695Zm0 0"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M450.086 117.684c-183.574 0-332.402 148.828-332.402 332.402 0 183.578 148.828 332.398 332.402 332.398 183.578 0 332.398-148.82 332.398-332.398 0-183.574-148.82-332.402-332.398-332.402Zm0 595.554c-145.34 0-263.152-117.816-263.152-263.148 0-145.34 117.812-263.152 263.152-263.152 145.336 0 263.148 117.816 263.148 263.152 0 145.332-117.812 263.148-263.148 263.148Zm0 0"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M450.074 156.852c-161.937 0-293.222 131.285-293.222 293.222 0 161.942 131.285 293.215 293.222 293.215 161.942 0 293.215-131.273 293.215-293.215 0-161.937-131.273-293.222-293.215-293.222Zm0 525.355c-128.207 0-232.137-103.93-232.137-232.129 0-128.21 103.93-232.137 232.137-232.137 128.203 0 232.13 103.93 232.13 232.137 0 128.2-103.927 232.129-232.13 232.129Zm0 0"
}))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#c)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#d)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#e)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m484.36 339.363 47.19-57.62 70.227 57.51-47.191 57.622Zm0 0"
}))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#f)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#g)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M110.766 50.969h113.742v78.062H110.766Zm0 0"
})))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#h)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#i)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#j)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#k)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M435.082 583.676c13.996-10.36 31.66-20.059 45.656-30.418 13.996-10.36 27.825-21.887 39.317-33.078 6.332-5.68 11.324-12.36 16.488-17.871 4.996-6.68 9.988-13.36 13.816-19.872 9.989-13.359 15.973-29.718 25.457-46.578l2-2.671c5.657-10.352 19.325-14.708 29.672-9.043 6.508 3.828 11.02 10.332 10.86 17.507 2.03 22.356-.442 46.555-9.086 69.254-4.32 11.352-9.98 21.703-16.805 32.223-6.992 9.351-13.816 19.871-23.48 27.223-16.653 16.703-37.317 30.406-58.653 39.441-21.332 9.031-43.172 14.562-67.02 14.422-11.84.512-20.355-8.992-20.87-20.836.156-7.176 3.984-13.688 9.484-16.863Zm0 0"
})))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#l)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#m)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#n)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#o)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M419.508 571.855c13.996-10.359 31.66-20.054 45.656-30.414 13.996-10.363 27.82-21.89 39.316-33.082 6.329-5.68 11.325-12.359 16.489-17.87 4.992-6.68 9.988-13.36 13.816-19.872 9.988-13.36 15.973-29.715 25.457-46.578l1.996-2.672c5.66-10.351 19.328-14.703 29.676-9.043 6.508 3.832 11.016 10.332 10.86 17.508 2.027 22.356-.442 46.555-9.087 69.254-4.324 11.351-9.98 21.703-16.804 32.223-6.992 9.351-13.817 19.87-23.48 27.222-16.657 16.703-37.317 30.407-58.653 39.442-21.336 9.03-43.172 14.562-67.02 14.422-11.84.511-20.359-8.989-20.87-20.836.156-7.176 3.984-13.688 9.484-16.864Zm0 0"
})))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#p)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#q)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#r)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M564.96 411.566 619 413.45l-1.887 54.04-54.035-1.884Zm0 0"
}))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#s)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#t)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#u)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m411.152 568.574 54.04 1.883-1.883 54.04-54.04-1.884Zm0 0"
}))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#v)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M117.684 121.043h99.77v347.25h-99.77Zm0 0"
}))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#w)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#x)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#y)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#z)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M630.887 847.207c-32.297-5.352-68.504-16.523-100.801-21.875-32.3-5.352-65.953-8.95-96.098-9.836-15.949-1.121-31.5.867-45.695 1.106-15.55 1.988-31.102 3.976-44.898 7.32-31.098 3.98-61.004 17.289-96.168 26.527l-6.223.797c-21.371 5.895-45.137-6.871-51.043-28.242-3.352-13.797-.48-28.387 9.406-37.555 27.508-31.965 63.387-60.261 105.332-78.273 20.973-9.004 42.344-14.899 65.469-19.438 21.77-2.785 44.894-7.324 67.465-3.886 44.34.648 89.879 10.628 129.992 27.625 40.117 16.992 76.168 39.25 107.195 71.632 16.188 15.313 14.52 39.235-.789 55.418-9.886 9.168-23.683 12.512-35.168 9.239Zm0 0"
})))))));
export default SvgCharm;